import type { ChipVariant } from "../../../components/common/chip";
import type { LoyaltyPromotionDto } from "../../../api";
import { isWindowActive } from "./resolve-effective-multiplier";

export type PromotionStatus = { label: string; variant: ChipVariant };

/** Active = enabled AND in window. Scheduled = enabled but starts in the future. */
export function promotionStatus(p: LoyaltyPromotionDto, now = new Date()): PromotionStatus {
  if (!p.enabled) return { label: "Disabled", variant: "rejected" };
  if (p.startsAt && new Date(p.startsAt).getTime() > now.getTime())
    return { label: "Scheduled", variant: "secondary" };
  if (!isWindowActive(p.startsAt, p.endsAt, now)) return { label: "Expired", variant: "tertiary" };
  return { label: "Active", variant: "approved" };
}

export const formatPromoDate = (v: string | null | undefined) =>
  v ? new Date(v).toLocaleDateString("en-GB") : "—";

export function promotionScopeLabel(p: LoyaltyPromotionDto): string {
  return p.scope === "ALL"
    ? "All products"
    : `${p.productIds.length} product${p.productIds.length === 1 ? "" : "s"}`;
}
